<template>
  <div class="page-gallery">
    <div
      class="page-header header-accent-gradient card-base card-shadow--small"
    >
      <h1>Galeria</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"
          ><i class="mdi mdi-home-outline"></i
        ></el-breadcrumb-item>
        <!-- TODO poner idioma aqui -->
        <!--  -->
        <el-breadcrumb-item>Home</el-breadcrumb-item>
        <el-breadcrumb-item>Gallery</el-breadcrumb-item>
        <el-breadcrumb-item>Album</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="flex justify-flex-end">
        <el-button
          type="primary"
          round
          icon="el-icon-plus"
          @click="outerVisible = true"
        >
          Subir imagen</el-button
        >
      </div>
    </div>

    <div id="container">
      <ProfileGallery :images="images" @delete="handlerDeletion" />
    </div>
    <el-dialog
      title="Cargar imagenes"
      :visible.sync="outerVisible"
      width="30%"
      center
    >
      <el-upload
        ref="uploadfiles"
        class="upload-demo"
        drag
        :action="imageUri"
        :on-success="handlerSuccess"
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          <!-- Suelta tu archivo aquí o <em>haz clic para cargar</em> -->
        </div>
        <div slot="tip" class="el-upload__tip">
          <!-- Solo archivos jpg/png con un tamaño menor de 500kb -->
        </div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ProfileGallery from "@/components/Profile/ProfileGallery";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";

Vue.use(Viewer);

export default {
  name: "GalleryPhotos",
  props: ["id", "boxMargins"],
  data() {
    return {
      outerVisible: false,
      add: false,
      loading: true,
      imageUri: `https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile`,
      images: []
    };
  },
  mounted() {
    this.loadIamges();
  },
  components: {
    ProfileGallery
  },
  methods: {
    handlerDeletion() {
      setTimeout(() => {
        this.loadIamges();
      }, 1000);
    },
    handleCancel() {
      this.outerVisible = false;
      this.$refs.uploadfiles.abort();
      this.$refs.uploadfiles.clearFiles();
    },

    loadIamges() {
      this.$http
        .get(`/api/gallery/AlbumsPhothos?AlbumId=${this.id}`)
        .then((response) => {
          let data = response.data.map((i) => i.Uri);
          this.images = data;
          this.outerVisible = false;
        });
    },

    handlerSuccess(res) {
      const items_count = res.length;

      for (var index = 0; index < items_count; index++) {
        //save record to db
        let entity = {};
        entity.AlbumID = this.id;
        entity.Url = res[index].Url;
        entity.Filename = res[index].Name;
        this.$http.post(`/api/gallery/saveFileName`, entity);
      }
      setTimeout(() => {
        this.loadIamges();
      }, 1000);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.profile-gallery {
  /*.images-list {
		margin: 0 -10px;
		margin-top: -10px;

		img {
			cursor: pointer;
			width: calc(50% - 20px);
			border-radius: 10px;
			max-width: 278px;
			float: left;
			box-sizing: border-box;
			margin: 10px;
			border: 5px solid #fff;
			box-shadow: 0px 7px 20px -7px rgba(0, 0, 0, 0.55);
			transition: all .5s;

			&:hover {
				box-shadow: none;
				transform: translateY(3px);
			}
		}
	}*/
  .upload-demo {
    align-content: center;
    align-items: center;
  }
  .images-list {
    overflow: hidden;
    margin: -1%;
    &.box-margins {
      margin: 1%;
    }

    img {
      cursor: pointer;
      width: 18%;
      border-radius: 10px;
      //max-width: 278px;
      float: left;
      box-sizing: border-box;
      margin: 1%;
      border: 5px solid #fff;
      box-shadow: 0px 7px 20px -7px rgba(0, 0, 0, 0.55);
      transition: all 0.5s;

      &:hover {
        box-shadow: none;
        transform: translateY(3px);
      }
    }
  }
}

@media (max-width: 768px) {
  .profile-gallery {
    .images-list {
      margin: -1.5%;
      &.box-margins {
        margin: 1.5%;
      }

      img {
        width: 30.3%;
        margin: 1.5%;
      }
    }
  }
}
@media (max-width: 480px) {
  .profile-gallery {
    .images-list {
      margin: -2%;
      &.box-margins {
        margin: 2%;
      }

      img {
        width: 46%;
        margin: 2%;
      }
    }
  }
}
@media (max-width: 360px) {
  .profile-gallery {
    .images-list {
      margin: -2%;
      &.box-margins {
        margin: 2%;
      }

      img {
        width: 96%;
        margin: 2%;
      }
    }
  }
}
</style>
